/**
 * THE INVITE TOKEN IS MINTED HERE, ONCE — in the browser, where the mail body is composed.
 *
 * Founder ruling on R91 (2026-09-19): "I want to show exactly what is sent and later accepted. Any
 * divergence leads to potential issues and unhappy customers." Until P018 the create page minted a
 * `generateToken()` value (a `yyddHHmm` stamp plus `Math.random()` — time-correlated, guessable,
 * L07 F6) and the E lane replaced it server-side with a CSPRNG token, so the Message Preview named
 * a code the email did not carry. Now the browser mints the same shape the API accepts and keeps
 * (`identity.es.ts` `INVITE_TOKEN_SHAPE`: 15 CSPRNG bytes, base64url, exactly 20 characters —
 * never 16 like the legacy generator, never 32 like a practice link, which the app routes
 * differently), so preview, email, row and the Invites list carry ONE value. The API still mints
 * when a caller sends a legacy-shaped or already-used token, and rebinds the body then.
 */
const INVITE_TOKEN_BYTES = 15;

export const INVITE_TOKEN_SHAPE = /^[A-Za-z0-9_-]{20}$/;

const toBase64Url = (bytes: Uint8Array): string =>
  btoa(bytes.reduce((acc, b) => acc + String.fromCharCode(b), ''))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/** The browser's CSPRNG. Resolved at call time so a test can run where `window.crypto` is absent. */
const browserRandomValues = (array: Uint8Array<ArrayBuffer>): Uint8Array<ArrayBuffer> =>
  globalThis.crypto.getRandomValues(array);

export const mintInviteToken = (
  getRandomValues: (array: Uint8Array<ArrayBuffer>) => Uint8Array<ArrayBuffer> = browserRandomValues,
): string => toBase64Url(getRandomValues(new Uint8Array(INVITE_TOKEN_BYTES)));
